import { render, staticRenderFns } from "./Learn__Section--CreateClovers.vue?vue&type=template&id=8cffd4fa&lang=pug&"
import script from "./Learn__Section--CreateClovers.vue?vue&type=script&lang=js&"
export * from "./Learn__Section--CreateClovers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports